import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, addToCart, onProductClick, wishlistIds, onToggleFav }) => {
    if (!products || !products.length) {
        return <div className="text-center py-16 text-gray-400 text-lg">Товары не найдены</div>;
    }
    const favSet = wishlistIds instanceof Set ? wishlistIds : new Set(wishlistIds || []);

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
                <ProductCard
                    key={product.id}
                    product={product}
                    onOpen={() => onProductClick(product)}
                    addToCart={addToCart}
                    isFav={favSet.has(String(product.id))}
                    onToggleFav={onToggleFav}
                />
            ))}
        </div>
    );
};

export default ProductGrid;